import { Component, HostBinding, Input, Signal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { NgTemplateOutlet } from '@angular/common';

import { SdThemeComponent } from '@seb/web-design-system/core';

import type {
  IContact, ILocation, INavigationFooter, IServiceOptions, IReviewSkeeper
} from '../../_interfaces/navigation-footer.interface';

import { SdAccordionComponent } from '../accordion-group/accordion/accordion.component';
import { SdAccordionGroupComponent } from '../accordion-group/accordion-group.component';
import { SdBannerComponent } from '../medias/banner/banner.component';
import { DeviceService } from '../../_services/device.service';
import { ImageRatioEnum } from '../../_enums/image-ratio.enum';
import { IconSizeEnum } from '../../_enums/icon.enum';
import { PositionEnum } from '../../_enums/position.enum';
import { ReviewEnum } from '../../_enums/review.enum';
import { SdIconComponent } from '../icons/icon/icon.component';
import { SdLinkComponent } from '../links/link/link.component';
import { ThemesEnum } from '../../_enums/themes.enum';
import { SdHtmlComponent } from '../html/html.component';

@Component({
  selector: 'sd-navigation-footer',
  templateUrl: './navigation-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdHtmlComponent,
    SdLinkComponent,
    SdBannerComponent,
    SdIconComponent,
    SdAccordionGroupComponent,
    SdAccordionComponent,
    TranslateModule,
    NgTemplateOutlet
  ]
})
export class SdNavigationFooterComponent extends SdThemeComponent {
  @Input()
  navigationFooter: INavigationFooter[];

  @Input()
  themesConfig: ThemesEnum.light | ThemesEnum.dark = ThemesEnum.light;

  @Input()
  contact: IContact;

  @Input()
  serviceOptions: IServiceOptions[];

  @Input()
  location: ILocation;

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel = 2;

  @Input()
  review: IReviewSkeeper;

  @Input()
  class = ''; // override the standard class attr with a new one.

  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.themesConfig ? 'is-theme-' + this.themesConfig : '',
      this.brand || this.activeBrand ? 'is-active-brand' : '',
      this.class
    ]
      .filter(Boolean)
      .join(' ');
  }

  imageRatio = ImageRatioEnum;
  positionEnum = PositionEnum;
  themesEnum = ThemesEnum;
  iconSize = IconSizeEnum;
  reviewEnum = ReviewEnum;
  isDevice: Signal<boolean>;

  constructor(
    protected deviceService: DeviceService,
  ) {
    super();
    this.isDevice = toSignal(deviceService.isDevice);
  }

}
